import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  Badge,
} from '../../../shared/components/ui';
import {
  formatCurrency,
  formatRelativeDate,
} from '../../../shared/utils/formatters';

function EstimateStatusBadge({ status }) {
  if (status === 'complete') {
    return (
      <Badge variant="green" dot>
        Complete
      </Badge>
    );
  }
  return (
    <Badge variant="yellow" dot>
      Draft
    </Badge>
  );
}

export function RecentEstimatesTable({ estimates = [], onViewAll }) {
  const navigate = useNavigate();

  const handleRowClick = (estimateId) => {
    navigate(`/estimates/${estimateId}`);
  };

  return (
    <Card className="mb-8">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Recent Estimates</CardTitle>
        {onViewAll && (
          <button
            onClick={onViewAll}
            className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 font-medium"
          >
            View all &rarr;
          </button>
        )}
      </CardHeader>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Project / Customer</TableHead>
              <TableHead>Total Cost</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Created</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {estimates.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} className="text-center text-gray-500 dark:text-gray-400 py-8">
                  No estimates yet. Create your first estimate to get started.
                </TableCell>
              </TableRow>
            ) : (
              estimates.map((estimate) => (
                <TableRow
                  key={estimate.estimateId || estimate.id}
                  onClick={() => handleRowClick(estimate.estimateId || estimate.id)}
                  className="cursor-pointer"
                >
                  <TableCell>
                    <div>
                      <p className="font-medium text-gray-900 dark:text-gray-100">
                        {estimate.projectName || estimate.jobName}
                      </p>
                      <p className="text-xs text-gray-500 dark:text-gray-400">
                        {estimate.clientName || estimate.customer}
                      </p>
                    </div>
                  </TableCell>
                  <TableCell className="font-medium text-gray-900 dark:text-gray-100">
                    {formatCurrency(estimate.totalCost || estimate.finalPrice || estimate.aiSuggestedPrice)}
                  </TableCell>
                  <TableCell>
                    <EstimateStatusBadge status={estimate.status || 'complete'} />
                  </TableCell>
                  <TableCell className="text-gray-500 dark:text-gray-400 text-sm">
                    {formatRelativeDate(estimate.estimateDate || estimate.createdAt)}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

export default RecentEstimatesTable;
